import React, { createContext, useContext, useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const defaultSiteSettings = {
  whatsappNumber: '+919876543210',
  email: 'eliteexperience@gmail.com'
};

const SiteDataContext = createContext({
  siteSettings: defaultSiteSettings,
  destinations: []
});

export const SiteDataProvider = ({ children }) => {
  const [siteSettings, setSiteSettings] = useState(defaultSiteSettings);
  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/site-settings`)
      .then(res => res.json())
      .then(data => setSiteSettings(data))
      .catch(err => console.error('Error fetching site settings:', err));

    fetch(`${API_URL}/api/destinations`)
      .then(res => res.json())
      .then(data => setDestinations(data))
      .catch(err => console.error('Error fetching destinations:', err));
  }, []);

  return (
    <SiteDataContext.Provider value={{ siteSettings, destinations }}>
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = () => useContext(SiteDataContext);
